import { PLATFORMS } from '@/utilities/constants/game';
import { AggregationData } from '../types';
import { useStore } from '@/store/useStore';

const variantMapper = {
  [PLATFORMS.Android]: 'android',
  [PLATFORMS.Desktop]: 'web',
  [PLATFORMS.XSELL]: 'xsell-android',
  [PLATFORMS.MobileWeb]: 'web',
};

const enum SLICE_TYPE {
  GAME_WINDOW = 'game_window',
  DASHBOARD = 'dashboard',
  GAME_HELP = 'game_help',
}

const variantSelector = (
  gameWindow: AggregationData['gameWindow']['data']['primary'] | undefined,
) => {
  const targetVariant = variantMapper[useStore.getState().runtime.platform];

  return gameWindow
    ? Object.values(gameWindow).find(
        (value) =>
          Array.isArray(value) &&
          value?.find((val) => val?.primary?.variant === targetVariant),
      )
    : undefined;
};

export const getGameWindowData = (
  gameWindow: AggregationData['gameWindow']['data']['primary'] | undefined,
) => {
  const variant = variantSelector(gameWindow);
  return Array.isArray(variant)
    ? variant.find((elem) => elem?.slice_type === SLICE_TYPE.GAME_WINDOW)
    : undefined;
};

export const getGameHelpData = (
  gameWindow: AggregationData['gameWindow']['data']['primary'] | undefined,
) => {
  const variant = variantSelector(gameWindow);
  return Array.isArray(variant)
    ? variant.find((elem) => elem?.slice_type === SLICE_TYPE.GAME_HELP)
    : undefined;
};
